import {MDBBreadcrumb, MDBBreadcrumbItem, MDBRow} from "mdbreact"
import AddEditDealerModal from "../../components/RegionAndDealers/addEditDealerModal"
import DealerGrid from "../../components/RegionAndDealers/dealerGrid"
import RegionGrid from "../../components/RegionAndDealers/regionGrid"

const RegionAndDealers = () => (
    <>
        <MDBBreadcrumb>
            <MDBBreadcrumbItem> Administration </MDBBreadcrumbItem>
            <MDBBreadcrumbItem active>Region & Dealers</MDBBreadcrumbItem>
        </MDBBreadcrumb>
        <MDBRow>
            <RegionGrid />
            <DealerGrid />
            <AddEditDealerModal />
        </MDBRow>
    </>
)

export default RegionAndDealers
